//================================================================
//  Tab: Vendor Risk Rating
//================================================================

//  Purpose: This tab displays all 'Vendor Risk Rating' of a Vendor

//  Example:
//    <VendorRiskRating></VendorRiskRating>    

//================================================================

//Libraries
import React, { useContext, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

//Contexts
import { GetUser } from '../../../../../Library/GlobalContexts';

//Components
import PageComponent from '../../../../../Components/PageComponent/PageComponent';

//Functions
import QueryListener from '../../../../../Library/QueryListener';


export default function VendorRiskRating() {

  //------------------------------------------------------
  //  useContext & React Router
  //------------------------------------------------------

  const getUser = useContext(GetUser);
  const params = useParams();

  //------------------------------------------------------
  //  useStates
  //------------------------------------------------------

  // Used to save page status > 'pending', 'onload', 'error-invalid', 'error-fatal'
  const [pageStatus, setPageStatus] = useState('pending');

  // Holds the application document from 
  const [vendorDoc, setVendorDoc] = useState();

  //------------------------------------------------------
  //  useEffects
  //------------------------------------------------------

  // Query Listener
  // - Get Firestore document
  useEffect(() => {

    const vendorid = params.id;

    if (vendorid === '') return;
    if (vendorid === null) return;

    function onLoadChange(documents) {

      if (documents[0] === undefined) return  setPageStatus('forbidden');

      setVendorDoc(documents[0]);
      setPageStatus('onload');

    }

    function onError(error) {

      console.log(error);
      setPageStatus('error-fatal');

    }

    const unsubscribe = QueryListener('vendors', [['vendorid', '==', vendorid]], onLoadChange, onLoadChange, onError);

    return () => {
      unsubscribe();
    };

  // eslint-disable-next-line
  }, [getUser]);

  //------------------------------------------------------
  //  HTML
  //------------------------------------------------------

  return (
    <PageComponent
      status={pageStatus}
      body={
        <div className='flex flex-col w-[50%] px-[10px]'>

          {/* Overall Rating */}
          <div className='FormComponent-Row'>
            <label className='font-medium'>Overall Rating</label>
            <div className='flex flex-row gap-2'>
              <input
                className='Input-Field-Text'
                type='text'
                value={vendorDoc?.overallrating?.score !== '' && vendorDoc?.overallrating !== undefined ? `${vendorDoc?.overallrating?.grade} - ${vendorDoc?.overallrating?.score}` : "-"}
                defaultValue={'-'}
                disabled={true}
              ></input>
            </div>
          </div>
          <div className='text-gray-500 text-[14px] pl-1'>
            {
              vendorDoc?.lastcyberriskupdated ?
                (
                  () => {
                    const date = vendorDoc.lastcyberriskupdated.toDate();
                    const formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}, ${date.toLocaleTimeString('en-US', { hour12: true })}`;
                    return `Last updated ${formattedDate}`;
                  }
                )()
                :
                ''
            }
          </div>

          {/* Automated Rating */}
          <div className='FormComponent-Row'>
            <label className='font-medium'>Automated Rating</label>
            <div className='flex flex-row gap-2'>
              <input
                className='Input-Field-Text'
                type='text'
                value={vendorDoc?.automatedrating?.score !== ''  && vendorDoc?.automatedrating !== undefined ? `${vendorDoc?.automatedrating?.grade} - ${vendorDoc?.automatedrating?.score}` : "-"}
                defaultValue={'-'}
                disabled={true}
              ></input>
            </div>
          </div>
          <div className='text-gray-500 text-[14px] pl-1'>
            {
              vendorDoc?.lastcyberriskupdated ?
                (
                  () => {
                    const date = vendorDoc.lastcyberriskupdated.toDate();
                    const formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}, ${date.toLocaleTimeString('en-US', { hour12: true })}`;
                    return `Last updated ${formattedDate}`;
                  }
                )()
                :
                ''
            }
          </div>

          {/* Questionnaire Rating */}
          <div className='FormComponent-Row'>
            <label className='font-medium'>Questionnaire Rating</label>
            <div className='flex flex-row gap-2'>
              <input
                className='Input-Field-Text'
                type='text'
                value={vendorDoc?.questionnairerating?.score !== ''  && vendorDoc?.questionnairerating !== undefined ? `${vendorDoc?.questionnairerating?.grade} - ${vendorDoc?.questionnairerating?.score}` : "-"}
                defaultValue={'-'}
                disabled={true}
              ></input>
            </div>
          </div>
          <div className='text-gray-500 text-[14px] pl-1'>
            {
              vendorDoc?.lastcyberriskupdated ?
                (
                  () => {
                    const date = vendorDoc.lastcyberriskupdated.toDate();
                    const formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}, ${date.toLocaleTimeString('en-US', { hour12: true })}`;
                    return `Last updated ${formattedDate}`;
                  }
                )()
                :
                ''
            }
          </div>



          <br></br>
        </div>
      }
    ></PageComponent>
  )
}
